import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowDown,
  faArrowUp,
  faArrowsLeftRightToLine,
  faBackward,
  faBackwardStep,
  faBan,
  faBarcode,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCertificate,
  faChartSimple,
  faChartGantt,
  faCheck,
  faCircle,
  faCircleInfo,
  faCircleNodes,
  faCirclePlus,
  faCircleQuestion,
  faCopy,
  faDatabase,
  faDownload,
  faExpand,
  faEye,
  faEyeSlash,
  faFileExport,
  faFilter,
  faFont,
  faForward,
  faGear,
  faGlobe,
  faHouse,
  faImage,
  faLanguage,
  faLink,
  faMagnifyingGlass,
  faMagnifyingGlassChart,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMobileScreenButton,
  faMusic,
  faPause,
  faPlay,
  faPlus,
  faPowerOff,
  faRotateLeft,
  faRotateRight,
  faSignIn,
  faTable,
  faThumbTack,
  faTrash,
  faUser,
  faUserGear,
  faUsers,
  faVideo,
  faVolumeDown,
  faVolumeHigh,
  faVolumeLow,
  faVolumeOff,
  faVolumeUp,
  faVolumeXmark,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

library.add(faArrowDown);
library.add(faArrowUp);
library.add(faArrowsLeftRightToLine);
library.add(faBackward);
library.add(faBackwardStep);
library.add(faBan);
library.add(faBarcode);
library.add(faCaretDown);
library.add(faCaretLeft);
library.add(faCaretRight);
library.add(faCaretUp);
library.add(faChartSimple);
library.add(faChartGantt);
library.add(faCertificate);
library.add(faCheck);
library.add(faCircle);
library.add(faCircleInfo);
library.add(faCircleNodes);
library.add(faCirclePlus);
library.add(faCircleQuestion);
library.add(faCopy);
library.add(faDatabase);
library.add(faDownload);
library.add(faExpand);
library.add(faEye);
library.add(faEyeSlash);
library.add(faFileExport);
library.add(faFilter);
library.add(faFont);
library.add(faForward);
library.add(faGear);
library.add(faGlobe);
library.add(faHouse);
library.add(faImage);
library.add(faLanguage);
library.add(faLink);
library.add(faMagnifyingGlass);
library.add(faMagnifyingGlassChart);
library.add(faMagnifyingGlassMinus);
library.add(faMagnifyingGlassPlus);
library.add(faMobileScreenButton);
library.add(faMusic);
library.add(faPause);
library.add(faPlay);
library.add(faPlus);
library.add(faPowerOff);
library.add(faRotateLeft);
library.add(faRotateRight);
library.add(faSignIn);
library.add(faTable);
library.add(faThumbTack);
library.add(faTrash);
library.add(faUser);
library.add(faUserGear);
library.add(faUsers);
library.add(faVideo);
library.add(faVolumeDown);
library.add(faVolumeLow);
library.add(faVolumeHigh);
library.add(faVolumeOff);
library.add(faVolumeUp);
library.add(faVolumeXmark);
library.add(faXmark);

export default FontAwesomeIcon;
